import Vue from 'vue'
import VueRouter from 'vue-router'

import base from './base' // 默认页面路由(简繁体)
import yzzx from './yzzx' // 月子中心路由
import dayu from './dayu' // 大禹路由

Vue.use(VueRouter)


var routes = [];
routes = routes.concat(base, yzzx, dayu);
 
const router = new VueRouter({
  routes
})

export default router
